interface PaginationSkeletonProps {
  variant?: "compact" | "default";
}

export default function PaginationSkeleton({ variant = "default" }: PaginationSkeletonProps) {
  return (
    <div className="flex items-start md:items-center justify-end flex-col md:flex-row sticky">
      {variant !== "compact" && (
        <div className="hidden sm:flex items-center mr-6">
          <span className="text-label-large mr-1 text-transparent">Rows per page:</span>
          <div className="w-[68px]">
            <div className="h-8 bg-gradient-to-r from-sys-brand-surface-container-highest to-sys-brand-surface-container-low rounded-lg animate-pulse" />
          </div>
        </div>
      )}
      <div className="flex items-center justify-center md:justify-end w-full md:w-fit gap-4">
        <div className="text-label-large">
          <div className="h-5 w-20 bg-gradient-to-r from-sys-brand-surface-container-highest to-sys-brand-surface-container-low rounded animate-pulse" />
        </div>
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-gradient-to-r from-sys-brand-surface-container-highest to-sys-brand-surface-container-low rounded animate-pulse" />
          <div className="w-10 h-10 bg-gradient-to-r from-sys-brand-surface-container-highest to-sys-brand-surface-container-low rounded animate-pulse" />
        </div>
      </div>
    </div>
  );
}
